<div class="fuel-changes-map">
  <div class="fuel-changes-map__map">
    <app-common-map [mapHeight]="'100%'" [isCollapsed]="isCollapsed" [data]="fuelChangesData"
      [clusterRenderer]="clusterRenderer" [showDropdown]="false" [markerFactory]="markerFactory"
      [mapInfoWindowBuilder]="mapInfoWindowBuilder" [routeLink]="routeLink" [mapCenter]="mapCenter"
      [isLoading]="isLoading" [currencySymbol]="currencySymbol" [mapTypeControl]="mapTypeControl"
      [mapTypeId]="mapTypeId">
    </app-common-map>
  </div>
</div>